// Sandbox flags for snippet iframes: scripts, forms and popups are allowed, but
// there is intentionally NO allow-same-origin, so the frame runs in an opaque
// origin with no access to the host page's cookies, DOM, or storage.
export const SNIPPET_SANDBOX = 'allow-scripts allow-popups allow-forms';

// postMessage `type` used by the in-iframe resize reporter.
export const SNIPPET_HEIGHT_MESSAGE_TYPE = 'omq-snippet-height';

// Height bounds applied on the parent side (px).
export const SNIPPET_MIN_HEIGHT = 24;
export const SNIPPET_MAX_HEIGHT = 4000;
